import axios from './http';
import Cookies from 'js-cookie'

export const comlogin = params => axios.post('/company/user/login', params);
export const sendcode = params => axios.post('/api/user/sendcode', params);
export const register = params => axios.post('/api/user/register', params);
export const forgetpassword = params => axios.post('/api/user/forgetpassword', params);
export const checksmscode = params => axios.post('/api/user/checksmscode', params);
export const login = params => axios.post('/school/strategy/login', params);
export const getDashboard = params => axios.post('/school/student/getdata', params);




// WEBPACK FOOTER //
// ./src/api/user.js